export default __webpack_public_path__ + "static/1_26-e9ef2b454d5a5a803cbe6a2d627268e5.png";